<template>
    <div class="ipoint-topup ipoint-payment myaddress">
        <label class="profile-radio pay_type" @click="checkRadio(1,$event)">
                    <span class="pro-radio" v-bind:class="{'pro-radio-checked':tag==1}" style="margin-top: 12px;">
                        <span class="pro-radio-inner"></span>
                        <input type="radio" class="pro-radio-input">
                    </span>
            <div class="payment-group payment-group-paypal">
                <button type="button" class="payment-icon">
                    <img src="../../../assets/profile/visa.jpg" alt="" width="88">
                </button>
            </div>
        </label>

        <label class="profile-radio pay_type" @click="checkRadio(3,$event)">
                    <span class="pro-radio" v-bind:class="{'pro-radio-checked':tag==3}" style="margin-top: 12px;">
                    <span class="pro-radio-inner"></span>
                        <input type="radio" class="pro-radio-input">
                    </span>
            <div class="payment-group payment-group-paypal">
                <button type="button" class="payment-icon">
                    <img src="../../../assets/profile/paypal.png" alt="">
                </button>
            </div>
        </label>

        <!--<label class="profile-radio pay_type" @click="checkRadio(4,$event)">-->
                    <!--<span class="pro-radio" v-bind:class="{'pro-radio-checked':tag==4}" style="margin-top: 12px;">-->
                    <!--<span class="pro-radio-inner"></span>-->
                        <!--<input type="radio" class="pro-radio-input">-->
                    <!--</span>-->
            <!--<div class="payment-group payment-group-paypal">-->
                <!--<button type="button" class="payment-icon">-->
                    <!--<img src="../../../assets/profile/alipay.jpg" alt="">-->
                <!--</button>-->
            <!--</div>-->
        <!--</label>-->
    </div>
</template>
<script>
    export default {
        data () {
            return {
                tag: this.flag,
            }
        },
        props: {
            id: Number,
            checkedNum: {
                type: Number,
                default: 0
            },
            flag: {
                type: Number,
                default: 1
            }

        },
        methods: {
            checkRadio (index, e) {
                this.$emit('on-checked-radio', index)
                this.tag = index
                if (e.target.nodeName === 'INPUT') {
                    this.tag = index
                }
            },
        }
    }
</script>
<style lang="scss">
    .ipoint-payment{
        width: 100%;
        max-width: 700px;
        display: flex;
        label{
            width: 20%;
        }
    }
    .pay_type{
        margin-top: 15px;
    }

    .payment-group {
        margin-left: 20px;
    }

    .pay-title {
        font-size: 24px;
        margin-bottom: 10px;
    }

    .payment-input {
        border: 1px solid #99A9BF;
        border-radius: 5px;
        padding: 5px;
        line-height: 2;
        width: 100%;
        font-size: 16px;
        &::-webkit-input-placeholder, &::-moz-placeholder {
            color: #99A9BF;
        }
    }

    .payment-group-paypal {
        display: flex;
        align-items: center;
        button{
            img{
                width: 100%;
            }
        }
    }

    .payment-icon {
        border:none;
        background: transparent;
        padding: 0 5px 5px 5px;
        border-radius: 5px;
        img {
            display: inherit;
        }
    }

    .payment-desc {
        margin-left: 20px;
    }

    @media (max-width: 414px) {
        .ipoint-payment{
            display: block;
            label{
                width: 100%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Mypayment.vue?409ef9f4